(function($) {
    $(document).ready(function() {
        // Function to scroll to the element
        function scrollToElement(target) {
            var $target = $(target);
            var menuHeight = 120; // Adjust the number to the height of your sticky menu

            if ($target.length) {
                $('html, body').stop().animate({
                    'scrollTop': $target.offset().top - menuHeight
                }, 900, 'swing');
            }
        }

        // Event handler for clicks on anchor links
        $('.single-post .content a[href^="#"]').on('click', function(e) {
            e.preventDefault();
            var target = this.hash;
            scrollToElement(target);

            // Update the location hash using 'history.pushState' to avoid the default behavior.
            // 'window.location.hash = ...' can cause page jump which we don't want after smooth scrolling.
            history.pushState(null, null, target);
        });


        // Check if page is loaded with a hash and apply the offset
        window.onload = function() {
            if (window.location.hash) {
                console.log("Scrolling to position:" + window.location.hash);
                scrollToElement(window.location.hash);
            }
        }
    });
})(jQuery);